// Web Components: BSPopover, ThemeTooltip, BSTooltip, BSModal
// Gestiscono popover, tooltip e modali Bootstrap come custom elements.
// Attributi richiesti: data-bs-trigger per popover
// Dipendenze: bootstrap, presenza di attributi data specifici
// Limiti: richiede struttura HTML compatibile e presenza di Bootstrap
// Utilizzato per integrare componenti Bootstrap come custom elements
// Web Component: BSPopover
// Descrizione: Gestisce i popover Bootstrap come custom element.
// Attributi accettati:
//   - data-bs-trigger: trigger del popover (es. 'hover', 'focus')
// Eventi emessi: nessuno
// Dipendenze: Bootstrap
// Limiti: richiede struttura HTML compatibile e presenza di Bootstrap
// Utilizzo: usato per popover custom
class BSPopover extends HTMLElement {
  constructor() {
    super();
    this.options = {};

    if(this.dataset.bsTrigger != undefined)
      this.options.trigger = this.dataset.bsTrigger;
    
    new bootstrap.Popover(this, this.options);
  }
}
if (!window.customElements.get("bs-popover")) {
  window.customElements.define("bs-popover", BSPopover);
}

// Utility: ThemeTooltip
// Descrizione: Wrapper per istanziare un tooltip Bootstrap su un elemento.
// Attributi accettati: nessuno specifico
// Eventi emessi: nessuno
// Dipendenze: Bootstrap
// Limiti: usato solo internamente
// Utilizzo: helper per BSTooltip
class ThemeTooltip {
  constructor(element) {
    this.options = {};
    new bootstrap.Tooltip(element, this.options);
  }
}

// Web Component: BSTooltip
// Descrizione: Gestisce i tooltip Bootstrap come custom element.
// Attributi accettati: nessuno specifico
// Eventi emessi: nessuno
// Dipendenze: Bootstrap
// Limiti: richiede struttura HTML compatibile e presenza di Bootstrap
// Utilizzo: usato per tooltip custom
class BSTooltip extends HTMLElement {
  constructor() {
    super();
    new ThemeTooltip(this);
  }
}
if (!window.customElements.get("bs-tooltip")) {
  window.customElements.define("bs-tooltip", BSTooltip);
}

// Web Component: BSModal
// Descrizione: Gestisce le modali Bootstrap come custom element, con supporto per delay, scroll e persistenza.
// Attributi accettati:
//   - data-delay: delay in ms prima di mostrare la modale
//   - data-scroll: percentuale di scroll per mostrare la modale
//   - data-remember: giorni di persistenza per non mostrare la modale
// Eventi emessi: nessuno
// Dipendenze: Bootstrap
// Limiti: richiede struttura HTML compatibile e presenza di Bootstrap
// Utilizzo: usato per modali custom con logica avanzata
class BSModal extends HTMLElement {
  delay; modal; scroll; scrollHandler; cansShow; days;

  constructor(){
    super();
    this.init();
  } 

  init = () => {
    this.delay = isNaN(parseInt(this.dataset.delay)) ? 0 : parseInt(this.dataset.delay);
    this.scroll = isNaN(parseInt(this.dataset.scroll)) ? 0 : parseInt(this.dataset.scroll);
    this.days = isNaN(parseInt(this.dataset.remember)) ? 0 : parseInt(this.dataset.remember);
    this.modal = new bootstrap.Modal(this);
    this.checkCanShow();

    if(this.cansShow){
      if(this.dataset.delay != undefined){
        this.handleDelay();
      }
  
      if(this.dataset.scroll != undefined){
        this.scrollHandler = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.scrollHandler, false);
      }

      if(this.dataset.remember != undefined && this.days > 0){
        this.addEventListener('hidden.bs.modal', () => this.remember());
      }
    }
  }

  remember = () => {
    localStorage.setItem(this.id, Date.now() + this.days * 24 * 60 * 60 * 1000);
  } 

  checkCanShow = () => {
    const stamp = parseInt(localStorage.getItem(this.id));
    this.cansShow = false;
    if(isNaN(stamp) || stamp < Date.now()){
      this.cansShow = true;
    }
  }

  handleScroll = () => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const scrollPercentage = this.scroll / 100;
    if(scrollPosition / pageHeight > scrollPercentage){
      this.show();
      window.removeEventListener('scroll', this.scrollHandler, false);
    }
  }

  handleDelay = () => {
    setTimeout(() => {
      this.show();
    }, this.delay);
  }

  show = () => {
    this.modal.show();
  }
}
if (!window.customElements.get("bs-modal")) {
  window.customElements.define("bs-modal", BSModal);
}